import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import CampaignDialog from "./CampaignDialog";

const CreateCampaignDialog = ({ isOpen, onClose, onCreate }) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setName("");
    setDescription("");
    queueMicrotask(() => inputRef.current?.focus());
  }, [isOpen]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const normalizedName = name.trim();
    if (!normalizedName) return;

    onCreate({
      name: normalizedName,
      description: description.trim(),
    });
  };

  return (
    <CampaignDialog
      description={t("campaigns.createHint")}
      isOpen={isOpen}
      onClose={onClose}
      title={t("campaigns.create")}
      titleEyebrow={t("campaigns.eyebrow")}
    >
      <form className="campaign-form-grid" onSubmit={handleSubmit}>
        <label htmlFor="create-campaign-name">
          {t("campaigns.form.name")}
          <input
            id="create-campaign-name"
            maxLength="80"
            placeholder={t("campaigns.form.namePlaceholder")}
            ref={inputRef}
            required
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </label>
        <label htmlFor="create-campaign-description">
          {t("campaigns.form.description")}
          <textarea
            id="create-campaign-description"
            placeholder={t("campaigns.form.descriptionPlaceholder")}
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </label>
        <footer className="campaign-dialog-footer">
          <button className="campaign-ghost-button" type="button" onClick={onClose}>
            {t("common.cancel")}
          </button>
          <button className="campaign-primary-button" type="submit">
            {t("campaigns.create")}
          </button>
        </footer>
      </form>
    </CampaignDialog>
  );
};

export default CreateCampaignDialog;
